import { takeLatest, put, call, SagaReturnType } from 'redux-saga/effects';
import { laborHoursConstant } from 'src/redux/actions/constant';
import laborHoursService from 'src/services/apiServices/laborHoursService/laborHoursService';

function* getLaborValidationToggle(): SagaReturnType<any> {
  try {
    yield put({ type: laborHoursConstant.GET_LABOR_VALIDATION_TOGGLE_LOADER });
    const response = yield call(laborHoursService.getLaborValidationToggle);
    if (response?.status === 200) {
      yield put({
        type: laborHoursConstant.GET_LABOR_VALIDATION_TOGGLE_SUCCESS,
        payload: response.data,
      });
    } else {
      throw response.data;
    }
  } catch (error) {
    yield put({ type: laborHoursConstant.GET_LABOR_VALIDATION_TOGGLE_FAILURE, payload: error });
  }
}

function* getLaborValidationToggleSaga() {
  yield takeLatest(
    laborHoursConstant.GET_LABOR_VALIDATION_TOGGLE_REQUEST,
    getLaborValidationToggle
  );
}

export default getLaborValidationToggleSaga;
